import React, {useEffect, useState} from 'react';
import "./HeaderDesktop.scss"
import {useBasket, useDispatchBasket, useMall, useUser} from "../../../hooks";
import SimpleLineIcon from "react-simple-line-icons";
import {NewMessageCount_api} from "../../../Components/HomeHeader/HomeHeaderServices";
import {useHistory} from "react-router-dom";
import {NavDataApi} from "../../../Components/Nav/NavServices";
import {getMallMerchant_api} from "../../../Services/apis";
import {GetBasket} from "../../../Components/OnlineAddress/OnlineAddressService";
import {getMallWithSubDomain} from "../../../Services";

function HeaderDesktop ({mId=null,active="home"}){
     const malli = useMall();
    const user = useUser();
    const history = useHistory();
    const basket = useBasket();
    const basketDispatch = useDispatchBasket();

    const goTo = (path)=>{
        history.push(path);
    }



    const [subState,set_SubState]= useState(false);

    const checkSubDomain = ()=>{
        let full = window.location.hostname;
        let parts = full.split('.');


        let sub = parts[0];

        if(sub==="www" || sub==="test")
            sub = parts[1];

        if(sub==="digimaall" || sub==="test" || sub==="stage" || sub==="localhost" || sub==="apluss" || sub==="app"){
            sub = "digimaall"
        }

        if(sub!=="digimaall"){
            set_SubState(false)
        }else {
            set_SubState(true)
        }
    }



    const handleProfileName = () =>  {
        if(token){
            let localUser = localStorage.getItem('user');
            if(localUser){localUser = JSON.parse(localUser);}

            let userObj = localUser?localUser:user;
            if (userObj){
                if(userObj.first_name){
                    return userObj.first_name+" "+userObj.last_name;
                }else {
                    return "بدون نام";
                }
            }else {
                return "بدون نام";
            }
        }else {
            return "ورود / ثبت نام"
        }

    }

    const handleProfilePhone = () =>  {
        let localUser = localStorage.getItem('user');
        if(localUser){localUser = JSON.parse(localUser);}
        let userObj = localUser?localUser:user;
        if (userObj){
            if(userObj.phone){return userObj.phone;}
        }else {
            return "بدون شماره";
        }
    }

    const handleProfileImage = () =>  {
        let localUser = localStorage.getItem('user');
        if(localUser){localUser = JSON.parse(localUser);}
        let userObj = localUser?localUser:user;
        if (userObj){
            if(userObj.image){return userObj.image;}
        }else {
            return "/other/profile-default-icon.png";
        }
    }

    const [localLogo,setLocalLogo] = useState("");
    const [bellCount,set_bellCount] = useState("")

    useEffect(()=>{
        let loc = localStorage.getItem('mallLogo');
        setLocalLogo(loc?loc:'/other/brand.png');
        getNewMessageCount()
        // getMall()
        // getMallDetail()
        basketApi()
        getToken()
        checkSubDomain()
    },[])

    useEffect(()=>{
       setTimeout(()=>{
           getMallDetail()
       },1000)
    },[])

    const [token,set_token] = useState(null)
    const getToken = ()=>{
            set_token(localStorage.getItem('token'))
    }

    const basketApi = async () =>{
        const response = await GetBasket();

        if(response.data.items &&  response.data.items.length>0){
            let maped = response.data.items.map(item=>{
                return {count:item.quantity,product:item.product}
            })
            basketDispatch(maped)
            localStorage.setItem("basket",JSON.stringify(maped))
        }else {
            //empty
            basketDispatch([])
            localStorage.setItem("basket",JSON.stringify([]))
        }
    }

    const [merchant,set_merchant] = useState({})

    useEffect(()=>{
        getMallMerchant()
        getNav()
    },[malli])

    const getMallMerchant = async()=>{
        try{
            const res = await getMallMerchant_api()
            set_merchant(res.data)
        }catch(e){
            console.log(e)
        }
    }

    const getNewMessageCount = async ()=>{
        try{
            const res = await NewMessageCount_api()
            set_bellCount(res.data.count)
        }catch (e) {
            console.log("error : ",e)
        }
    }


    const [mall,set_mall] = useState(null)


    // const getMall = () =>{
    //     try{
    //         const localMall = localStorage.getItem('mall')
    //         if(localMall){
    //             set_mall(JSON.parse(localMall))
    //         }
    //     }catch(e){
    //         console.log(e)
    //     }
    // }

    const getMall = async (sub)=>{
        try {
            return  await getMallWithSubDomain(sub);
        }
        catch (e) {
            console.log(e)
        }
    }

    const getMallDetail= async()=>{
        //detect sub or main link
        let full = window.location.hostname;
        let parts = full.split('.');

        let sub = "";
        let isAdmin = "";

        if(parts.length===3 && parts[0]!=="www"){
            sub = parts[0]
        }else{
            sub = "app"
        }

        isAdmin = parts[0];

        if(isAdmin==="www" || isAdmin==="test")
            isAdmin = parts[1];

        if(isAdmin==="digimaall" || isAdmin==="test" || isAdmin==="stage" || isAdmin==="localhost" || isAdmin==="apluss"  || isAdmin==="app"){
            let temp = isAdmin;
            isAdmin = "digimaall";
            if(temp==="app" && parts[1] !== "apluss"){
                isAdmin = "app"
                console.log("in")
            }
            // if(temp==="app" && parts[1] !== "digimaall"){
            //     isAdmin = "app"
            //     console.log("out")
            // }

        }


        let token = localStorage.getItem("token");

        if(isAdmin!=="digimaall"){
            let malli = await getMall(sub)
            localStorage.setItem('mallId',malli.data.uid);
            localStorage.setItem('mallLogo',malli.data.header_image);
            localStorage.setItem('mallWhite',malli.data.logo);
            localStorage.setItem('mallName',malli.data.name);
            localStorage.setItem('mall',JSON.stringify(malli.data));
            localStorage.setItem('theme',JSON.stringify({
                primary:malli.data.primary_color.color,
                secondary:malli.data.secondary_color.color,
                tertiary:malli.data.tertiary_color.color
            }));
            console.log("Mall : ",malli)
            set_mall(malli.data)
        }
    }


    // Nav
    const [aPosition,set_aPosition] = useState({label:"خانه",link:"home",image:"/navbar/home_icon.svg",select_image:"/navbar/home_icon_select.svg"})
    const [bPosition,set_bPosition] = useState({label:"فروشگاه",link:"store",image:"/navbar/_store_icon.svg",select_image:"/navbar/store_icon_select.svg"})
    const [cPosition,set_cPosition] = useState({label:"اسکن",link:"scan",image:"/navbar/_scan_icon.svg",select_image:"/navbar/scan_icon_select.svg"})
    const [dPosition,set_dPosition] = useState({label:"پاداش",link:"reward",image:"/navbar/gift_icon.svg",select_image:"/navbar/gift_icon_select.svg"})

    const getNav = async()=>{
        try{
            const res= await NavDataApi()
            if(res.data.length>0 && res.data[0].items.length > 0){
                let data = res.data[0].items ;
                // A position
                let ap = data.find(d=>d.position==="right")
                if(ap)
                    set_aPosition({...aPosition,label:ap.title,link:ap.link_to_uid,image:ap.image?ap.image:aPosition.image,select_image:ap.select_image?ap.select_image:aPosition.select_image})

                // B position
                let bp = data.find(d=>d.position==="right_top")
                if(bp)
                    set_bPosition({...bPosition,label:bp.title,link:bp.link_to_uid,image:bp.image?bp.image:bPosition.image,select_image:bp.select_image?bp.select_image:bPosition.select_image})

                // C position
                let cp = data.find(d=>d.position==="left")
                if(cp)
                    set_cPosition({...cPosition,label:cp.title,link:cp.link_to_uid,image:cp.image?cp.image:cPosition.image,select_image:cp.select_image?cp.select_image:cPosition.select_image})

                // D position
                let dp = data.find(d=>d.position==="left_top")
                if(dp)
                    set_dPosition({...dPosition,label:dp.title,link:dp.link_to_uid,image:dp.image?dp.image:dPosition.image,select_image:dp.select_image?dp.select_image:dPosition.select_image})
            }
            // set_call(true)
        }catch(e){
            // set_call(true)
            console.log("e",e)
        }
    }

    const GoTo = (page,text) => {
        history.push("/" + page,{navLabel:text});
    }

    const calculateBasket = () => {
        let count = 0;
        basket.forEach(item => {
            count += item.count
        })
        return count
    }




    return(
        <>
            <div className="header-desktop-container">
                <div className="header-desktop-left">
                    {/*<div className="header_sec3" >*/}
                    {/*    <SimpleLineIcon name="envelope" style={{fontSize:25}}/>*/}
                    {/*    {bellCount>0?<span className="bell-count">{bellCount}</span>:null}*/}
                    {/*</div>*/}
                    <div className="user-card">
                        <SimpleLineIcon name="phone" />
                        <span>{mall && mall.phone?mall.phone:"---"}</span>
                    </div>
                    <div className="user-card" onClick={e=>{
                        if(token)
                            history.push("/profile")
                            else
                            history.push("/login");
                    }}>
                        <SimpleLineIcon name="user" />
                        <span>{handleProfileName()}</span>
                    </div>

                    {subState && token?<div className="user-card" onClick={e=>{
                        history.push("/malls")
                    }}>
                        <SimpleLineIcon name="home" />
                        <span>مراکز خرید</span>
                    </div>:null}


                </div>
                <div className="header-desktop-right">

                    <div className="header-desktop-logo">
                        {/*<span>{mall?mall.name:""}</span>*/}
                        <div className="header-desktop-info">
                            <span className="header-desktop-info-name">{mall?mall.name:""}</span>
                            <span className="header-desktop-info-address">{mall?mall.description:""}</span>
                        </div>
                        <img src={mall?mall.header_image:localLogo} alt=""/>
                    </div>
                </div>
            </div>
            <div>
                <div className="desktop-menu">
                    <div className="header-desktop-menu">

                        <div className="header-desktop-menu-item" onClick={e=>{goTo("/about")}}>
                            <span>درباره ما</span>
                            {/*<SimpleLineIcon name="calendar"/>*/}
                        </div>
                        <div className="header-desktop-menu-item"  onClick={()=>{goTo(`faq/${merchant.uid}`)}} >
                            <span>سوالات متداول</span>
                            {/*<SimpleLineIcon name="calendar"/>*/}
                        </div>
                        <div className="header-desktop-menu-item" onClick={e=>{goTo("/festivals")}}>
                            <span>جشنواره</span>
                            {/*<SimpleLineIcon name="book-open"/>*/}
                        </div>


                        <div className="header-desktop-menu-item" onClick={() => GoTo(dPosition.link,dPosition.label)}>
                            <span>{dPosition.label}</span>
                        </div>

                        <div className="header-desktop-menu-item" onClick={() => GoTo(cPosition.link,cPosition.label)}>
                            <span>{cPosition.label}</span>
                        </div>

                        <div className={active==="shop"?"header-desktop-menu-item active-tab":"header-desktop-menu-item"} onClick={() => GoTo(bPosition.link,bPosition.label)}>
                            <span>{bPosition.label}</span>
                        </div>

                        <div className={active==="home"?"header-desktop-menu-item active-tab":"header-desktop-menu-item"} onClick={() => GoTo(aPosition.link,aPosition.label)}>
                            <span>{aPosition.label}</span>
                        </div>
                    </div>

                    {mId?<div className="desktop-menu-basket">
                        <i className="fa fa-shopping-cart" onClick={() => {
                            history.push("/online-store-basket/" + mId)
                        }}>
                            <span className="cart-badg">{calculateBasket()}</span>
                        </i>
                    </div>:null}

                </div>
            </div>
            </>
    )
}

export default HeaderDesktop;
